import { HonorariumLiquidationProfessionalStatusId } from '../../dto/HonorariumLiquidationDTO';

interface LiquidationProfessionalStatusTagProps {
    statusId: number;
    /** Descripción que manda el backend ("Pendiente", "Pagado"). */
    status: string;
}

/** Si al profesional ya se le pagó su liquidación (DS §3.4). */
export default function LiquidationProfessionalStatusTag({ statusId, status }: LiquidationProfessionalStatusTagProps) {
    const variant = statusId === HonorariumLiquidationProfessionalStatusId.PAID ? 'md-tag-ok' : 'md-tag-warn';
    return <span className={`md-tag ${variant}`}>{status}</span>;
}
